module.exports = __webpack_public_path__ + "static/media/home-services-2.8e67d4ac.jpeg";